import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import linkedin from "../assets/linkedin.svg";
import github from "../assets/github.svg";
import pdfCv from "../files/cv.pdf";

const Socials = () => {
  return (
    <SocialsList>
      <li>
        <a href="https://github.com/cataraul" target="_blank">
          <img src={github} alt="github" />
        </a>
      </li>
      <li>
        <a
          href="https://www.linkedin.com/in/raul-domnita-90936a204/"
          target="_blank"
        >
          <img src={linkedin} alt="linkedin" />
        </a>
      </li>
      <li>
        <Link to={pdfCv} target="_black">
          <button>CV</button>
        </Link>
      </li>
    </SocialsList>
  );
};

export default Socials;

const SocialsList = styled.ul`
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-basis: 40%;
  list-style-type: none;
  li {
    a {
      img {
        height: 2rem;
        width: 2rem;
        transition: transform 0.3s ease-out;
        color: #1dacd6;
        &:hover {
          transform: scale(1.2);
        }
      }
    }
  }
  button {
    height: 3rem;
    min-width: 5rem;
    background-color: #2a52be;
    border: none;
    border-radius: 0.4rem;
    color: #fefefe;
    transition: all 0.3s ease;
    cursor: pointer;
    font-size: 1.2rem;
    &:hover {
      color: #2a52be;
      background-color: #fefefe;
      border: 1px solid #2a52be;
    }
  }
  @media only screen and (max-width: 685px) {
    flex-direction: column;
    height: 50%;
    width: 100%;
  }
`;
